module.exports = __webpack_public_path__ + "static/img/logo1.dc3d704e.jpg";